import React, { Component } from 'react'
import { localize } from '../util/Localizer'
import Card from '@material-ui/core/Card'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as languageActions from '../redux/actions/languageActions'
import { injectIntl } from 'react-intl'

import RBButton from '../controls/RBButton'
import TopNav from '../widgets/common/TopNav'

class ActivationComplete extends Component {
  render () {
    return (
      <Grid fluid className='activationCompletePage'>
        <TopNav primary />
        <Row>
          <Col xs={12} md={9} lg={6} className='wrapper'>
            <Card className='uiCard uiCardActivate'>
              <section className='activate activationComplete'>
                <Row>
                  <Col xs={12}>
                    <h3>{localize('pages.activationComplete.title')}</h3>
                    <p>{localize('pages.activationComplete.prompt')}</p>
                    <div className='buttonContainer'>
                      <RBButton
                        variant='contained'
                        id='confirmActivation'
                        label={localize('common.clickToContinue')}
                        primary
                        href='/Claims'
                        onClick={() => this.props.push('/Claims')} />
                    </div>
                  </Col>
                </Row>

              </section>
            </Card>
          </Col>
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state) {
  return {
  }
}
function mapDispatchToProps (dispatch) {
  return {
    languageActions: bindActionCreators(languageActions, dispatch),
    push: bindActionCreators(push, dispatch)
  }
}
const ConnectedActivationComplete = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ActivationComplete))

export default ConnectedActivationComplete



// WEBPACK FOOTER //
// ./src/components/ActivationComplete.js